import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { updateSeoForRoute } from '../utils/seo'

// Album Management
import AdminAlbumList from '../views/AdminAlbumList.vue';
import AdminAlbumEdit from '../views/AdminAlbumEdit.vue';
import AlbumList from '../views/AlbumList.vue';
import AlbumDetail from '../views/AlbumDetail.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/question',
    name: 'QuestionBank',
    component: () => import('../views/QuestionBank.vue')
  },
  {
    path: '/papers',
    name: 'papers',
    component: () => import('../views/PaperList.vue')
  },
  {
    path: '/papers/:id',
    name: 'PaperDetail',
    component: () => import('../views/PaperDetail.vue')
  },
  {
    path: '/paper-list',
    name: 'PaperList',
    redirect: '/papers'
  },
  {
    path: '/albums',
    name: 'AlbumList',
    component: AlbumList
  },
  {
    path: '/albums/:id',
    name: 'AlbumDetail',
    component: AlbumDetail
  },
  {
    path: '/activities',
    name: 'ActivityList',
    component: () => import('../views/ActivityList.vue')
  },
  {
    path: '/activities/:id',
    name: 'ActivityDetail',
    component: () => import('../views/ActivityDetail.vue')
  },
  {
    path: '/activities/:id/learn',
    name: 'ActivityLearn',
    component: () => import('../views/ActivityLearn.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/Test.vue')
  },
  {
    path: '/zujuan',
    name: 'Zujuan',
    component: () => import('../views/Zujuan.vue')
  },
  {
    path: '/test3',
    name: 'Test3',
    component: () => import('../views/Test3.vue')
  },
  {
    path: '/paper',
    name: 'PaperMaker',
    component: () => import('../views/PaperMaker.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/question_bank2',
    name: 'QuestionBank2',
    component: () => import('../views/QuestionBank2.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { guest: true }
  },
  {
    path: '/question-lists',
    name: 'QuestionLists',
    component: () => import('../views/QuestionLists.vue')
  },
  {
    path: '/question-lists/:id',
    name: 'QuestionListDetail',
    component: () => import('../views/QuestionListDetail.vue')
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: () => import('../views/UserProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/points-center',
    name: 'PointsCenter',
    component: () => import('../views/PointsCenter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/points-recharge',
    name: 'PointsRecharge',
    component: () => import('../views/PointsRecharge.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/invite-friend',
    name: 'InviteFriend',
    component: () => import('../views/InviteFriend.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/:id',
    name: 'UserSpace',
    component: () => import('../views/UserSpace.vue')
  },
  {
    path: '/forum',
    name: 'ForumList',
    component: () => import('../views/ForumList.vue')
  },
  {
    path: '/forum/:id',
    name: 'ForumPostDetail',
    component: () => import('../views/ForumPostDetail.vue')
  },
  {
    path: '/checkins/:id',
    name: 'CheckInDetail',
    component: () => import('../views/CheckInDetail.vue')
  },
  {
    path: '/forum/create',
    name: 'ForumCreatePost',
    component: () => import('../views/ForumCreatePost.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-feedback',
    name: 'MyFeedback',
    component: () => import('../views/MyFeedback.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('../views/Chat.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: "Admin",
    component: () => import('../views/AdminLayout.vue'),
    redirect: '/admin/dashboard',
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: 'chat-manager',
        name: 'AdminChatManager',
        component: () => import('../views/AdminChatManager.vue')
      },
      {
        path: 'users',
        name: 'AdminPanel',
        component: () => import('../views/AdminPanel.vue')
      },
      {
        path: 'forum-manager',
        name: 'AdminForumManager',
        component: () => import('../views/AdminForumManager.vue')
      },
      {
        path: 'textbook',
        name: 'AdminTextbookManager',
        component: () => import('../views/AdminTextbookManager.vue')
      },
      {
        path: 'questions',
        name: 'AdminQuestionManager',
        component: () => import('../views/AdminQuestionManager.vue')
      },
      {
        path: 'question-entry',
        name: 'AdminQuestionEntry',
        component: () => import('../views/AdminQuestionEntry.vue')
      },
      {
        path: 'import-questions',
        name: 'AdminImportQuestions',
        component: () => import('../views/AdminImportQuestions.vue')
      },
      {
        path: 'paper-import',
        name: 'AdminPaperImport',
        component: () => import('../views/AdminPaperImport.vue')
      },
      {
        path: 'albums',
        name: 'AdminAlbumList',
        component: AdminAlbumList
      },
      {
        path: 'albums/:id/edit',
        name: 'AdminAlbumEdit',
        component: AdminAlbumEdit
      },
      {
        path: 'paper-upload',
        name: 'AdminPaperUpload',
        component: () => import('../views/AdminPaperUpload.vue')
      },
      {
        path: 'paper-list',
        name: 'AdminPaperList',
        component: () => import('../views/PaperList.vue')
      },
      {
        path: 'oss-manager',
        name: 'AdminOSSManager',
        component: () => import('../views/AdminOSSManager.vue')
      },
      {
        path: 'ad-manager',
        name: 'AdminAdManager',
        component: () => import('../views/AdminAdManager.vue')
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('../views/AdminDashboard.vue')
      },
      {
        path: 'announcements',
        name: 'AdminAnnouncements',
        component: () => import('../views/AdminAnnouncements.vue')
      },
      {
        path: 'feedbacks',
        name: 'AdminFeedback',
        component: () => import('../views/AdminFeedback.vue')
      },
      {
        path: 'pay-test',
        name: 'AdminPayTest',
        component: () => import('../views/PayTest.vue')
      },
      {
        path: 'pricing',
        name: 'AdminPricing',
        component: () => import('../views/AdminPricing.vue')
      },
      {
        path: 'ip-blacklist',
        name: 'AdminIPBlacklist',
        component: () => import('../views/AdminIPBlacklist.vue')
      },
      {
        path: 'sensitive-words',
        name: 'AdminSensitiveWords',
        component: () => import('../views/AdminSensitiveWords.vue')
      },
      {
        path: 'moderation-logs',
        name: 'AdminModerationLog',
        component: () => import('../views/AdminModerationLog.vue')
      },
      {
        path: 'activities',
        name: 'AdminActivityManager',
        component: () => import('../views/AdminActivityManager.vue')
      },
      {
        path: 'activities/:id/edit',
        name: 'AdminActivityEdit',
        component: () => import('../views/AdminActivityEdit.vue')
      }
    ]
  },
  {
    path: '/banned',
    name: 'Banned',
    component: () => import('../views/Banned.vue')
  }
]

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes
})

// --- Page Tracking Logic ---
let pageEnterTime = 0;
let currentTrackedPath = '';
let currentTrackedTitle = '';

const sendPageVisitLog = () => {
  if (!currentTrackedPath || pageEnterTime === 0) return;

  const duration = Math.floor((Date.now() - pageEnterTime) / 1000); // in seconds
  if (duration > 0) {
    const payload = JSON.stringify({
      path: currentTrackedPath,
      title: currentTrackedTitle || document.title,
      duration: duration
    });

    // Use sendBeacon for reliable delivery during page unload
    if (navigator.sendBeacon) {
      const token = localStorage.getItem('token');
      // sendBeacon doesn't easily support custom headers like Authorization.
      // For visit logs, we might just rely on IP/fingerprint if token isn't easily sent,
      // or we can use fetch/axios with keepalive for SPA navigations.
      // Since this is primarily for SPA navigation, we'll try fetch with keepalive first,
      // and fallback to standard axios if needed, but sendBeacon is best for true unloads.

      const headers = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      try {
        fetch('/api/stats/page-visit', {
          method: 'POST',
          headers: headers,
          body: payload,
          keepalive: true // Important for background sending
        }).catch(e => console.error('Error sending visit log:', e));
      } catch (e) {
        console.error('Fetch failed, trying sendBeacon (no auth header)', e);
        navigator.sendBeacon('/api/stats/page-visit', new Blob([payload], { type: 'application/json' }));
      }
    }
  }
};

// Handle tab close or refresh
window.addEventListener('beforeunload', () => {
  sendPageVisitLog();
});
window.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    sendPageVisitLog();
    pageEnterTime = 0; // Prevent duplicate logging if they come back
  } else if (document.visibilityState === 'visible') {
    pageEnterTime = Date.now(); // Restart timer when tab becomes visible again
  }
});

router.beforeEach((to, from, next) => {
  // Before leaving the current route, send the log
  if (from.name && from.path !== to.path) {
    sendPageVisitLog();
  }
  next();
});

router.afterEach((to) => {
  // After entering a new route, start the timer
  pageEnterTime = Date.now();
  currentTrackedPath = to.fullPath;
  currentTrackedTitle = to.meta.title || to.name || 'Unknown Page';

  updateSeoForRoute(to);
});
// ----------------------------

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const isAuthenticated = !!token;

  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Redirect to login with return URL
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      });
    } else {
      // Check for admin role if required
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.role !== 'admin') {
          // Not an admin, redirect to home or show error
          next({ name: 'Home' });
          return;
        }
      }

      // Proactive check for ban status in localStorage
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.status === 'banned') {
        if (to.name !== 'Banned') {
          next({ name: 'Banned' });
          return;
        }
      }

      next();
    }
  }
  // Check if route is for guests only (login/register)
  else if (to.matched.some(record => record.meta.guest)) {
    if (isAuthenticated) {
      // Already logged in, redirect to home
      next({ name: 'Home' });
    } else {
      next();
    }
  }
  else {
    next();
  }
});

export default router
